import React from 'react';
import { ProductCardProps } from '../../types';
import { twMerge } from 'tailwind-merge';
import styles from '../corner-css/index.module.scss';
import checkProductCardShowMkplSection from '@/utils/mkpl/checkProductCardShowMkplSection';

export default function CardBodyMkplShip(props: Partial<ProductCardProps>) {
  const { data, className, showSoldBy = true, activityTagLimit = null, shipsFromClassName = 'enki-body-2xs' } = props;
  const { vender_info_view } = data ?? {};
  const { eta_range } = vender_info_view ?? {};

  const shipsFromText = checkProductCardShowMkplSection(data, activityTagLimit)?.shipsFromText || '';

  if (!!shipsFromText && showSoldBy) {
    return (
      <div
        data-testid="wid-product-card-ships-from"
        onClick={e => e.stopPropagation()}
        className={twMerge(
          'max-w-full overflow-hidden flex items-center break-all',
          'text-surface-100-fg-minor',
          !!eta_range ? 'line-clamp-1' : 'whitespace-nowrap',
          className,
          styles.shipsFrom,
          shipsFromClassName
        )}
        dangerouslySetInnerHTML={{ __html: shipsFromText }}></div>
    );
  }
  return null;
}
